function searchData(input, onChange) {
    var data = input;

    return {
        get: function() {
            return data;
        },
        set: function(changeSet) {
            data = changeSet;

            if (typeof onChange === 'function') {
                onChange(data);
            }
        }
    };
}

export default searchData;
